import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

import { SelectArtistsPage, SelectMembersPage } from '../pages';
import BlacklistTradingPhotoCardsPage from '../pages/BlacklistTradingPhotoCardsPage';
import IdentityVerificationCallbackPage from '../pages/IdentityVerificationCallbackPage';
import ManageArtistPage from '../pages/ManageArtistPage';
import ManageMemberPage from '../pages/ManageMemberPage';
import MergeUserProfilesPage from '../pages/MergeUserProfilesPage';
import MyPhotoCardsWishPage from '../pages/MyPhotoCardsWishPage';
import PhotoCardDetailPage from '../pages/PhotoCardDetailPage';
import SelectArtistsPageForUnlike from '../pages/SelectArtistsPageForUnlike';
import UnauthorizedAccessPage from '../pages/UnauthorizedAccessPage';

import TradingPhotoCardChatRoomPage from '../pages/TradingPhotoCardChatRoomPage';
import TradingReportPage from '../pages/TradingReport';
import TradingUserListPage from '../pages/TradingUserListPage';
import MyTradingPhotoCardChatRoomsPage from '../pages/trading/MyTradingPhotoCardChatRoomsPage';

import ManageAccountPage from '../pages/ManageAccountPage';

import AddPhotoCardPage from '../pages/feed/AddPhotoCardPage';
import AddPostPage from '../pages/feed/AddPostPage';
import FeedHomePage from '../pages/feed/FeedHomePage';
import PostDetailPage from '../pages/feed/PostDetailPage';
import UserFeedProfilePage from '../presentation/feed/UserFeedProfilePage';

import ForceToUpdatePage from '../pages/ForceToUpdatePage';
import CreateFeedUserProfilePage from '../pages/feed/CreateFeedUserProfilePage';
import FeedReportPage from '../pages/feed/FeedReportPage';
import RepostsListPage from '../pages/feed/RepostsListPage';
import OnRouterChanged from '../utils/OnRouterChanged';
import ScrollToTop from '../utils/ScrollToTop';

import AddTradingPhotoCardReviewPage from '../pages/trading/AddTradingPhotoCardReviewPage';
import SelectReviewChatRoomPage from '../pages/trading/SelectReviewChatRoomPage';
import SelectTradingPhotoCardReviewPage from '../pages/trading/SelectTradingPhotoCardReviewPage';
import TradingPhotoCardReviewDetailPage from '../pages/trading/TradingPhotoCardReviewDetailPage';
import TradingPhotoCardReviewsPage from '../pages/trading/TradingPhotoCardReviewsPage';
import SelectTradePage from '../presentation/review/SelectTradePage';
import TradeReviewRequestPage from '../presentation/review/TradeReviewRequestPage';

import NotificationPage from '../pages/NotificationPage';
import TradingPhotoCardPageV2 from '../pages/TradingPhotoCardPageV2';
import AddTradingPhotoCardPageV2 from '../pages/trading/AddTradingPhotoCardPageV2';
import TradingUserProfilePage from '../pages/trading/TradingUserProfilePage';
import TradingUserProfileSettingsPage from '../pages/trading/TradingUserProfileSettingsPage';

import ReportPhotoCardActivitiesPage from '../pages/photo_cards/ReportPhotoCardActivitiesPage';
import ReportPhotoCardCandidatesPage from '../pages/photo_cards/ReportPhotoCardCandidatesPage';
import ReportPhotoCardCategoriesPage from '../pages/photo_cards/ReportPhotoCardCategoriesPage';
import ReportPhotoCardConfirmPage from '../pages/photo_cards/ReportPhotoCardConfirmPage';
import ReportPhotoCardEventsPage from '../pages/photo_cards/ReportPhotoCardEventsPage';
import ReportPhotoCardMiscActivitiesPage from '../pages/photo_cards/ReportPhotoCardMiscActivitiesPage';
import ReportPhotoCardUploadPhotoPage from '../pages/photo_cards/ReportPhotoCardUploadPhotoPage';
import { ReportSelectArtistPage } from '../pages/report/ReportSelectArtistPage';
import { ReportSelectMemberPage } from '../pages/report/ReportSelectMemberPage';
import AddTagInputPage from '../pages/tags/AddTagInputPage';
import CompletedAddTradingPhotoCardsPage from '../pages/trading/CompletedAddTradingPhotoCardsPage';
import ConfirmNewSalesTradingPhotoCardsPage from '../pages/trading/ConfirmNewSalesTradingPhotoCardsPage';

import LikedUserProfilesPage from '../pages/feed/LikedUserProfilesPage';
import UserProfileSearchPage from '../pages/feed/UserProfileSearchPage';

import FollowersPage from '../pages/FollowersPage';
import FollowingsPage from '../pages/FollowingsPage';
import OfflineEventDetailPage from '../pages/OfflineEventDetailPage';
import OfflineLocationDetailPage from '../pages/OfflineLocationDetailPage';
import OfflineLocationLikePage from '../pages/OfflineLocationLikePage';
import ReportedPhotoCardsPage from '../pages/ReportedPhotoCardsPage';
import ConfirmReportedPhotoCardsPage from '../pages/admin/ConfirmReportedPhotoCardsPage';

import SearchEventPage from '../pages/photo_cards/search/SearchEventPage';
import ReportPhotoCardPage from '../pages/report/ReportPhotoCardPage';
import AddReportFootprintPage from '../pages/report/location/AddReportFootprintPage';
import ReportFootprintsPage from '../pages/report/location/ReportFootprintsPage';
import AddSalesPriceTradingPhotoCardsPage from '../pages/trading/AddSalesPriceTradingPhotoCardsPage';
import EditGroupSalesTradingPhotoCardsPage from '../pages/trading/EditGroupSalesTradingPhotoCardsPage';
import EditPricesInTradingPhotoCardsPage from '../pages/trading/EditPricesInTradingPhotoCardsPage';
import TradingPhotoCardDetailPage from '../pages/trading/TradingPhotoCardDetailPage';
import OnboardingPage from '../pages/OnboardingPage';
import DMChatRoomPage from '../pages/DMChatRoomPage';
import DMListPage from '../pages/DMListPage';
import RequestVerificationCodePage from '../pages/RequestVerificationCodePage';
import LoginWithCodePage from '../pages/LoginWithCodePage';
import NicknameSettingPage from '../pages/NickNameSettingPage';
import WelcomePage from '../pages/WelcomePage';
import SearchArtistsPage from '../pages/SearchArtistsPage';
import SignupCompletePage from '../pages/SignupCompletePage';
import MyPage from '../presentation/my-page/MyPage';
import NewEditPage from '../presentation/template/edit-collected-photo-cards/NewEditPage';
import CollectionsHomePage from '../presentation/home/CollectionHomePage';
import MyTradingPhotoCardsPage from '../presentation/trading/MyTradingPhotoCardsPage';
import RegisterSalePhotoCardsPage from '../presentation/trading/RegisterSalePhotoCardsPage';
import RegisterSalePhotoCardsDescriptionPage from '../presentation/trading/RegisterSalePhotoCardsDescriptionPage';
import MyPhotoCardsMarket from '../presentation/market/MyPhotoCardsMarket';
import ImageSearchPage from '../presentation/image-search/ImageSearchPage';
import ChatMainPage from '../presentation/chat/ChatMainPage';
// import SearchTestPage from '../pages/SearchTestPage';
import ReportFootprintsSpotsPage from '../pages/report/location/ReportFootprintsSpotsPage';
import ReportSearchLocationPage from '../pages/report/location/ReportSearchLocationPage';
import ReportEventsPage from '../pages/report/location/ReportEventsPage';
import AddReportEventPage from '../pages/report/location/AddReportEventPage';
import ReportEventCompletePage from '../pages/report/location/ReportEventCompletePage';
import ReportEventGoodsPage from '../pages/report/location/ReportEventGoodsPage';
import ReportEventGoodsTypePage from '../pages/report/location/ReportEventGoodsTypePage';
import ReportEventAddDetails from '../pages/report/location/ReportEventAddDetails';
import AlreadyReportedEventPage from '../pages/report/location/AlreadyReportedEventPage';
import ReportEventCompleteEditPage from '../pages/report/location/ReportEventCompleteEditPage';
import ReportFootprintsCategoryPage from '../pages/report/location/ReportFootprintsCategoryPage';
import ReportFootprintsSelectActivityPage from '../pages/report/location/ReportFootprintsSelectActivityPage';
import AlreadyReportedFootprintPage from '../pages/report/location/AlreadyReportedFootprintPage';
import GuestRoute from './guards/GuestRoute';
import SelectAddCollectionMethodPage from '../presentation/template/SelectAddCollectionMethodPage';
import LoungeChatPage from '../presentation/chat/LoungeChatPage';

import BettieSettingPage from '../presentation/chat/BettieSettingPage';
import SettingBettieSpeechStylePage from '../presentation/chat/SettingBettieSpeechStylePage';
import BettieChatRoomPage from '../presentation/chat/BettieChatRoomPage';
import BettieChatListPage from '../presentation/chat/BettieChatListPage';
import BettieUsagePage from '../presentation/chat/BettieUsagePage';
import BettiePurchaseHistoryPage from '../presentation/chat/BettiePurchaseHistoryPage';
import BettieLetterDetailPage from '../presentation/chat/BettieLetterDetailPage';
import BettieFirstPurchasePage from '../presentation/chat/BettieFirstPurchasePage';
import BettieChangeProfilePage from '../presentation/chat/BettieChangeProfilePage';

import FreeChargePage from '../presentation/freeCharge/FreeChargePage';
import InviteFriendsPage from '../presentation/freeCharge/InviteFriendsPage';
import EnterRedeemCodePage from '../presentation/freeCharge/EnterRedeemCodePage';

import InicisPaymentLaunchPage from '../presentation/payment/InicisPaymentLaunchPage';
import PaymentBuyerInfoPage from '../presentation/payment/PaymentBuyerInfoPage';
import PaymentBillingPage from '../presentation/payment/PaymentBillingPage';
import PaymentFailPage from '../presentation/payment/PaymentFailPage';
import PaymentSuccessPage from '../presentation/payment/PaymentSuccessPage';
import RefundSuccessPage from '../presentation/payment/RefundSuccessPage';
import SubscriptionCancelPage from '../presentation/payment/SubscriptionCancelPage';
import SubscriptionCancelSuccessPage from '../presentation/payment/SubscriptionCancelSuccessPage';

import IdentityVerificationIntroPage from '../presentation/identities/IdentityVerificationIntroPage';
import IdentityVerificationRedirectPage from '../presentation/identities/IdentityVerificationRedirectPage';

import FanHeartsIframePage from '../presentation/my-page/FanHeartsIframePage';
import LandingPage from '../presentation/landing/LandingPage';

import FanBuddySettingPage from '../presentation/fanBuddy/FanBuddySettingPage';
import FanBuddyIntroPage from '../presentation/fanBuddy/FanBuddyIntroPage';
import FanBuddyCompleteStepPage from '../presentation/fanBuddy/FanBuddySettingCompletePage';
import FindFanBuddyCardPage from '../presentation/fanBuddy/FindFanBuddyCardPage';

import SceneIntroPage from '../presentation/scene/SceneIntroPage';
import SceneSettingPage from '../presentation/scene/SceneSettingPage';
import SceneMainPage from '../presentation/scene/SceneMainPage';
import ScenePreviewDetailPage from '../presentation/scene/ScenePreviewDetailPage';
import CastRelationshipsPage from '../presentation/scene/CastRelationshipsPage';
import SceneCommentsDetailPage from '../presentation/scene/SceneCommentsDetailPage';
import SceneOriginalEpisodesPage from '../presentation/scene/SceneOriginalEpisodesPage';
import SceneContactUsPage from '../presentation/scene/SceneContactUsPage';

function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          {/* 업데이트 페이지는 가드 밖에 둔다 */}
          <Route path="/ask_update" element={<ForceToUpdatePage />} />
          <Route element={<OnRouterChanged />}>
            {/* 가입 - 온보딩 - 다크 모드 완료 */}
            <Route path="/" element={<OnboardingPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            {/* 게스트 라우트 적용 */}
            <Route element={<GuestRoute />}>
              <Route path="/request-verification-code" element={<RequestVerificationCodePage />} />
              <Route path="/login-with-code" element={<LoginWithCodePage />} />
              <Route path="/nickname-setting" element={<NicknameSettingPage />} />
              <Route path="/welcome" element={<WelcomePage />} />
            </Route>
            <Route path="/search-artists" element={<SearchArtistsPage />} />
            <Route path="/signup-complete" element={<SignupCompletePage />} />
            <Route
              path="/identity_verification_callback"
              element={<IdentityVerificationCallbackPage />}
            />
            <Route path="/unauthorized_access" element={<UnauthorizedAccessPage />} />
            <Route path="/add-artists-complete" element={<SignupCompletePage />} />
            <Route path="/artists" element={<SelectArtistsPage />} />
            <Route path="/select_initial_artists" element={<SelectArtistsPage />} />
            <Route path="/artists/:artist_id/members" element={<SelectMembersPage />} />

            {/* 덕질 도감 - 다크 모드 완료 */}
            <Route path="/collections" element={<CollectionsHomePage />} />
            <Route path="/locations/like" element={<OfflineLocationLikePage />} />
            <Route path="/locations/:location_id" element={<OfflineLocationDetailPage />} />
            <Route
              path="/locations/:location_id/events/:event_id"
              element={<OfflineEventDetailPage />}
            />
            <Route path="/collected-photo-cards/edit" element={<NewEditPage />} />
            <Route path="/collections/select-method" element={<SelectAddCollectionMethodPage />} />

            {/* 양도판 - 다크 모드 완료 */}
            <Route path="/tradings/photo_cards" element={<TradingPhotoCardPageV2 />} />
            <Route
              path="/tradings/add_trading_photo_cards"
              element={<AddTradingPhotoCardPageV2 />}
            />
            <Route
              path="/tradings/add_sales_price"
              element={<AddSalesPriceTradingPhotoCardsPage />}
            />
            <Route
              path="/tradings/confirm_new_trading_photo_cards"
              element={<ConfirmNewSalesTradingPhotoCardsPage />}
            />
            <Route path="/tradings/completed_add" element={<CompletedAddTradingPhotoCardsPage />} />
            <Route
              path="/tradings/groups/:group_id/edit"
              element={<EditGroupSalesTradingPhotoCardsPage />}
            />
            <Route
              path="/tradings/groups/:group_id/edit-prices"
              element={<EditPricesInTradingPhotoCardsPage />}
            />
            <Route path="/trading_reports" element={<TradingReportPage />} />

            {/* 포카 상세 - 다크 모드 완료 */}
            <Route path="/photo_cards/:photo_card_id" element={<PhotoCardDetailPage />} />

            {/* 마이페이지 - 다크 모드 완료 */}
            <Route path="/my" element={<MyPage />} />
            <Route path="/artists/manage" element={<ManageArtistPage />} />
            <Route path="/members/manage" element={<ManageMemberPage />} />
            <Route path="/account/manage" element={<ManageAccountPage />} />
            <Route path="/artists/reset_all_cards" element={<SelectArtistsPageForUnlike />} />
            <Route path="/users/:user_id/my_photo_cards_wish" element={<MyPhotoCardsWishPage />} />
            <Route path="/my-photo-cards-market" element={<MyPhotoCardsMarket />} />

            {/* 양도 프로필 & 리뷰 - 다크 모드 완료 */}
            <Route
              path="/trading/user_profile/:user_profile_id"
              element={<TradingUserProfilePage />}
            />
            <Route
              path="/trading/user_profile/:user_profile_id/settings"
              element={<TradingUserProfileSettingsPage />}
            />
            <Route
              path="/trading_photo_cards/:trading_photo_card_id/my_chat_rooms"
              element={<MyTradingPhotoCardChatRoomsPage />}
            />
            <Route
              path="/trading_photo_cards/:trading_photo_card_id"
              element={<TradingPhotoCardDetailPage />}
            />
            <Route
              path="/trading_photo_cards/select_reviews"
              element={<SelectTradingPhotoCardReviewPage />}
            />
            <Route
              path="/trading_photo_cards/:trading_photo_card_id/select_chat_rooms"
              element={<SelectReviewChatRoomPage />}
            />

            <Route
              path="/trading_photo_cards/:trading_photo_card_id/add_review"
              element={<AddTradingPhotoCardReviewPage />}
            />
            <Route path="/reviews/add-review" element={<AddTradingPhotoCardReviewPage />} />
            <Route path="/reviews/:review_id" element={<TradingPhotoCardReviewDetailPage />} />
            <Route path="/trading_photo_cards/reviews" element={<TradingPhotoCardReviewsPage />} />
            <Route path="/reviews/select-trade" element={<SelectTradePage />} />
            <Route path="/reviews/trade-review-request" element={<TradeReviewRequestPage />} />

            {/* 양도 프로필 관리 - 다크 모드 완료 */}
            <Route
              path="/artists/:artist_id/trading_photo_card_users"
              element={<TradingUserListPage />}
            />
            <Route
              path="/artists/:artist_id/blacklist_trading_photo_cards"
              element={<BlacklistTradingPhotoCardsPage />}
            />
            <Route path="/my-trading-photo-cards" element={<MyTradingPhotoCardsPage />} />
            <Route
              path="/new-my-trading-photo-cards/register-sale"
              element={<RegisterSalePhotoCardsPage />}
            />
            <Route
              path="/new-my-trading-photo-cards/register-sale-description"
              element={<RegisterSalePhotoCardsDescriptionPage />}
            />

            {/* 제보하기 */}
            <Route path="/report/select-artist" element={<ReportSelectArtistPage />} />
            <Route path="/report/select-member" element={<ReportSelectMemberPage />} />
            <Route
              path="/report-photo-card/event-activities"
              element={<ReportPhotoCardActivitiesPage />}
            />
            <Route
              path="/report-photo-card/misc-activities"
              element={<ReportPhotoCardMiscActivitiesPage />}
            />
            <Route path="/report-photo-card/events" element={<ReportPhotoCardEventsPage />} />
            <Route
              path="/report-photo-card/card-categories"
              element={<ReportPhotoCardCategoriesPage />}
            />
            <Route
              path="/report-photo-card/card-candidates"
              element={<ReportPhotoCardCandidatesPage />}
            />
            <Route
              path="/report-photo-card/upload-photo"
              element={<ReportPhotoCardUploadPhotoPage />}
            />
            <Route path="/report-photo-card/confirm" element={<ReportPhotoCardConfirmPage />} />
            <Route path="/report/photo-card" element={<ReportPhotoCardPage />} />
            <Route path="/report-photo-card/search-events" element={<SearchEventPage />} />
            <Route path="/tags/add" element={<AddTagInputPage />} />
            <Route path="/reported-photo-cards" element={<ReportedPhotoCardsPage />} />

            <Route path="/report-location/spots" element={<ReportFootprintsSpotsPage />} />
            <Route path="/report-location/search-location" element={<ReportSearchLocationPage />} />
            {/* 제보하기 - 생일카페/전시회/전광판 */}
            <Route path="/report-location/events" element={<ReportEventsPage />} />
            <Route path="/report-location/events/new" element={<AddReportEventPage />} />
            <Route
              path="/report-location/events/already-reported"
              element={<AlreadyReportedEventPage />}
            />
            <Route
              path="/report-location/events/complete-edit"
              element={<ReportEventCompleteEditPage />}
            />
            <Route path="/report-location/events/complete" element={<ReportEventCompletePage />} />

            <Route path="/report-location/events/goods" element={<ReportEventGoodsPage />} />
            <Route
              path="/report-location/events/goods-type"
              element={<ReportEventGoodsTypePage />}
            />
            <Route path="/report-location/events/add-details" element={<ReportEventAddDetails />} />

            <Route path="/report-location/footprints" element={<ReportFootprintsPage />} />
            <Route
              path="/report-location/footprints-category"
              element={<ReportFootprintsCategoryPage />}
            />
            <Route
              path="/report-location/footprints/select-activity"
              element={<ReportFootprintsSelectActivityPage />}
            />
            <Route path="/report-location/footprints/new" element={<AddReportFootprintPage />} />
            <Route
              path="/report-location/footprints/already-reported"
              element={<AlreadyReportedFootprintPage />}
            />

            {/* 알림-채팅 - 다크 모드 완료 */}
            <Route path="/notifications" element={<NotificationPage />} />
            <Route path="/chats/:chat_room_id" element={<TradingPhotoCardChatRoomPage />} />
            <Route path="/dm" element={<DMListPage />} />
            {/* <Route path="/chat_rooms/:chat_room_id" element={<DMChatRoomPage />} /> */}
            <Route path="/chat_rooms/:chat_room_id/v2" element={<DMChatRoomPage />} />
            <Route path="/home" element={<ChatMainPage />} />
            <Route path="/feed" element={<ChatMainPage />} />
            <Route path="/bettie-setting" element={<BettieSettingPage />} />
            <Route path="/bettie-setting/speech-style" element={<SettingBettieSpeechStylePage />} />
            <Route path="/bettie-chats/:chatRoomId" element={<BettieChatRoomPage />} />
            <Route path="/bettie-chat-list" element={<BettieChatListPage />} />
            <Route path="/bettie/usage" element={<BettieUsagePage />} />
            <Route path="/bettie/purchase-history" element={<BettiePurchaseHistoryPage />} />
            <Route path="/bettie/letter/:letterId" element={<BettieLetterDetailPage />} />
            <Route path="/bettie/first-purchase" element={<BettieFirstPurchasePage />} />
            <Route
              path="/bettie/:chatRoomId/change-profile"
              element={<BettieChangeProfilePage />}
            />

            {/* 무료 충전소 */}
            <Route path="/free-charge" element={<FreeChargePage />} />
            <Route path="/free-charge/invite" element={<InviteFriendsPage />} />
            <Route path="/free-charge/enter-redeem-code" element={<EnterRedeemCodePage />} />

            {/* 씬 */}
            <Route path={ROUTES.SCENE.MAIN} element={<SceneMainPage />} />
            <Route path={ROUTES.SCENE.INTRO} element={<SceneIntroPage />} />
            <Route path={ROUTES.SCENE.SETTING} element={<SceneSettingPage />} />
            <Route path={ROUTES.SCENE.PREVIEW_DETAIL.PATH} element={<ScenePreviewDetailPage />} />
            <Route path={ROUTES.SCENE.CAST_RELATIONSHIPS} element={<CastRelationshipsPage />} />
            <Route path={ROUTES.SCENE.COMMENTS_DETAIL.PATH} element={<SceneCommentsDetailPage />} />
            <Route
              path={ROUTES.SCENE.ORIGINAL_EPISODES.PATH}
              element={<SceneOriginalEpisodesPage />}
            />
            <Route path={ROUTES.SCENE.CONTACT} element={<SceneContactUsPage />} />

            {/* 결제 및 본인인증 */}
            <Route
              path="/identity-verification/intro"
              element={<IdentityVerificationIntroPage />}
            />
            <Route
              path="/identity-verification/callback"
              element={<IdentityVerificationRedirectPage />}
            />
            <Route path="/payment/inicis" element={<InicisPaymentLaunchPage />} />
            <Route path="/payment/buyer-info" element={<PaymentBuyerInfoPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/fail" element={<PaymentFailPage />} />
            <Route path="/payment/billing" element={<PaymentBillingPage />} />
            <Route path="/refund-success" element={<RefundSuccessPage />} />
            <Route
              path="/subscription/:subscriptionId/cancel"
              element={<SubscriptionCancelPage />}
            />
            <Route
              path="/subscription/:subscriptionId/cancel-success"
              element={<SubscriptionCancelSuccessPage />}
            />

            {/* 피드 - 다크 모드 완료 */}
            <Route path="/lounge" element={<FeedHomePage />} />
            <Route path="/feed/create_feed_user_profile" element={<CreateFeedUserProfilePage />} />
            <Route path="/feed/add_photo_card" element={<AddPhotoCardPage />} />
            <Route path="/feed/report/" element={<FeedReportPage />} />
            <Route path="/feed/user_profile/:user_profile_id" element={<UserFeedProfilePage />} />
            <Route path="/feed/user_profile/search" element={<UserProfileSearchPage />} />
            <Route
              path="/feed/user_profile/:user_profile_id/followers"
              element={<FollowersPage />}
            />
            <Route
              path="/feed/user_profile/:user_profile_id/followings"
              element={<FollowingsPage />}
            />
            <Route path="/posts/:post_id" element={<PostDetailPage />} />
            <Route path="/posts/:post_id/reposts" element={<RepostsListPage />} />
            <Route path="/posts/:post_id/liked_profiles" element={<LikedUserProfilesPage />} />
            <Route path="/posts/add" element={<AddPostPage />} />
            <Route path="/lounge-chat" element={<LoungeChatPage />} />

            {/* 덕메 찾기 - 다크 모드 완료 */}
            <Route path="/fan-buddy/intro" element={<FanBuddyIntroPage />} />
            <Route path="/fan-buddy/setting" element={<FanBuddySettingPage />} />
            <Route path="/fan-buddy/setting-complete" element={<FanBuddyCompleteStepPage />} />
            <Route path="/fan-buddy/find" element={<FindFanBuddyCardPage />} />

            <Route
              path="/admin/reported-photo-cards/confirm"
              element={<ConfirmReportedPhotoCardsPage />}
            />

            <Route path="/fanhearts" element={<FanHeartsIframePage />} />
            <Route path="/landing" element={<LandingPage />} />

            {/* Deprecated routes */}
            <Route path="/users/merge_profiles" element={<MergeUserProfilesPage />} />

            {/* 이미지검색 페이지 */}
            <Route path="/image-search" element={<ImageSearchPage />} />
          </Route>
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
}
export default Router;
